import { Box, Button, Modal, Paper, TextField, Typography, useTheme } from "@mui/material";
import useStyles from "./styles";

// Componente controlado compartilhado da tela: usado 1x pelo menu de Tipos de
// Entrega/Meio de Entrega em FormularioTab e 3x pelos grupos de equipamento em
// FormularioTab/OpcoesEquipamento. Relocado de circuito/index.js (Task 6 da
// decomposição) para a raiz de circuito/, sem subpasta, encerrando o import
// circular que OpcoesEquipamento fazia de circuito/index.js.
export const ModalEditCheckbox = ({
  open,
  onClose,
  onSave,
  title,
  value,
  onChange,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Modal sx={styles?.modalEditCheckbox} open={open} onClose={onClose}>
      <Paper sx={styles?.paperModalEditCheckBoxLabel}>
        <Typography variant="mySubtitle">{title}</Typography>

        <TextField
          size="small"
          autoComplete="off"
          fullWidth
          value={value}
          onChange={onChange}
        />

        <Box sx={styles?.boxHandlerButtons}>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            onClick={onSave}
            variant="contained"
            disabled={!value?.trim()}
          >
            Salvar
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};
